import { CLEAR_SUB_GROUPS } from '../actions/groups'

const sub_groups = (state = {}, action = {}) => {
  switch (action.type) {
    case CLEAR_SUB_GROUPS:
      state = {}
      break
  }
  return state
}

export default sub_groups
